import type { ReactNode } from "react"
import { Badge } from "@/components/ui/badge"
import { cn } from "@/lib/utils"

const tones = {
  success: { badge: "border-success/30 bg-success/10 text-success font-bold px-2.5 py-0.5 rounded-full", dot: "bg-success" },
  warning: { badge: "border-warning/30 bg-warning/10 text-warning font-bold px-2.5 py-0.5 rounded-full", dot: "bg-warning" },
  danger: { badge: "border-destructive/30 bg-destructive/10 text-destructive font-bold px-2.5 py-0.5 rounded-full", dot: "bg-destructive" },
  neutral: { badge: "border-border/80 bg-muted/50 text-muted-foreground font-semibold px-2.5 py-0.5 rounded-full", dot: "bg-muted-foreground" },
} as const

export type StatusTone = keyof typeof tones

export function StatusBadge({ tone, dot = true, className, children }: {
  tone: StatusTone
  dot?: boolean
  className?: string
  children: ReactNode
}) {
  return (
    <Badge variant="outline" className={cn("transition-colors", tones[tone].badge, className)}>
      {dot && <span className={cn("mr-1.5 size-2 rounded-full", tones[tone].dot)} />}
      {children}
    </Badge>
  )
}
